import { useMutation, useQuery } from "@tanstack/react-query";
import { fetch3, fetch5 } from "../commonApis/commonApis";
import { ApiResponse } from "./loginApis";
const url = process.env.REACT_APP_BASE_URL;

type NotificationStatus = {
    seen: boolean;
}

export const useFetchNotificationsData = (page: number, searchFor: string) => {
    return useQuery({
        queryKey: ["NotificationsData"],
        queryFn: async () => {
            const res = await fetch3(
                `${url}/api/lm-notifications?page=${page}&searchFor=${searchFor}&type=lmClient`,
                "get"
            );

            if (!res || !res.data) {
                return res.message;
            }

            return res.data; // 👈 This returns your full user object
        },
        staleTime: 1000 * 60 * 5,
    });
};

export const useNotificationStatusMutation = (id: string) => {
    return useMutation({
        mutationFn: async (payload: NotificationStatus) => {
            const res: ApiResponse = await fetch5(
                `${url}/api/lm-notifications/${id}?type=lmClient`,
                "PATCH",
                payload
            );

            // Manually throw error if success is false
            if (!res.success) {
                throw res.message || "Something went wrong";
            }

            return res;
        },
        onSuccess: (data: any) => {
            console.log("✅ Notification status updated successfully:", data);
            return;
        },
        onError: (error: any) => {
            console.error("❌ Notification status update request failed:", error.message);
        },
    });
};